import React from 'react';
import { PropTypes } from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { RequiredWrapper } from '../../../core/formValidation';

const CustomerDetails = ({ children }) => {
  const { register, watch } = useFormContext();
  return (
    <div>
      <div className="form-group row" style={{ marginBottom: '0' }}>
        <div className="col-sm-6">
          <label>Customer Details</label>
        </div>
      </div>
      <div className="form-group row">
        <div className="form-group col">
          <RequiredWrapper value={watch('customerName')}>
            <input
              className="form-control"
              id="customerName"
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="Name"
              data-testid="customerName-reclaimation-form"
              {...register('customerName')}
            />
          </RequiredWrapper>
        </div>
        <div className="form-group col-sm-6">
          <RequiredWrapper value={watch('customerEmail')}>
            <input
              className="form-control"
              id="customerEmail"
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="Email"
              data-testid="customerEmail-reclaimation-form"
              {...register('customerEmail')}
            />
          </RequiredWrapper>
        </div>
        <div className="form-group col-sm-6">
          <RequiredWrapper value={watch('customerPhone')}>
            <input
              className="form-control"
              id="customerPhone"
              type="text"
              aria-describedby="descriptionHelp"
              placeholder="Phone number"
              data-testid="customerPhone-reclaimation-form"
              {...register('customerPhone')}
            />
          </RequiredWrapper>
        </div>
        {children}
      </div>
    </div>
  );
};

CustomerDetails.propTypes = {
  children: PropTypes.node,
};

export default CustomerDetails;
